import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "../../../node_modules/react-router-dom/dist/index";
import useAPI from "../../api/hooks/useAPI";
import { controlKeys } from "../../api/queryKeys";
import { DRAWER_TABS } from "../../utils/constants";
import ControlRemediationDrawer from "../posture/controls/components/ControlRemediationDrawer/ControlRemediationDrawer";

const ControlDrawerWrapper = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedControl, setSelectedControl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { fetchAllControls } = useAPI();

  const { data: controls, isLoading: isLoadingControl } = useQuery({
    queryKey: controlKeys.all,
    queryFn: fetchAllControls,
    select: (data) =>
      data.data.map((control) => ({
        ...control,
        id: control.control_id,
      })),
  });

  const resetSelection = useCallback(() => {
    setSelectedControl(null);
    setOpenDrawer(false);
    setSearchParams({});
  }, []);

  useEffect(() => {
    if (searchParams.get("control_id") && controls) {
      const control = controls.find(
        (control) =>
          control.control_id.toString() === searchParams.get("control_id")
      );
      if (control) {
        setSelectedControl(control);
        setOpenDrawer(true);
      }
    }
  }, [searchParams, controls]);
  return (
    <ControlRemediationDrawer
      open={openDrawer}
      onClose={resetSelection}
      selectedTab={DRAWER_TABS.CONTROL_TAB}
      selectedControl={selectedControl}
    />
  );
};

export default ControlDrawerWrapper;
